import React from 'react';

import { getUrlFromDocument } from '../../../helpers/routes/mapping';
import useDocumentById from '../../../hooks/useDocumentById';
import { Page } from '../../../types/page/page';
import { BreadcrumbLink } from './BreadcrumbLink';

export const BreadcrumbLinkContainer: React.FC<BreadcrumbLinkContainerProps> = (
  props
) => {
  const { documentId, documentType, current = false } = props;
  const { data } = useDocumentById<Page>(documentType, documentId);

  if (!data) {
    return null;
  }

  const { id, type } = data.breadcrumbParent || {};
  const url: string = getUrlFromDocument(data);
  const title: string = data.breadcrumb;

  return (
    <>
      {id && type && (
        <BreadcrumbLinkContainer documentId={id} documentType={type} />
      )}
      <BreadcrumbLink url={url} title={title} current={current} />
    </>
  );
};

type BreadcrumbLinkContainerProps = {
  documentId: string;
  documentType: string;
  current?: boolean;
};
